export const natures = [
  {
    id: "desire",
    title: "欲望与压抑",
    icon: "ri-fire-line",
    desc: "伦理片反复展示同一件事：越是被告知不能要的东西，越会以变形的方式回到生活里。压抑不会让欲望消失，只会让它更隐蔽。",
    point: "观察点：角色的「不能」是来自法律、道德，还是他人的目光？",
  },
  {
    id: "moral",
    title: "道德的相对性",
    icon: "ri-scales-2-line",
    desc: "同一件事，换个立场就换一套说法。优秀的作品不急着裁决，而是让观众同时容纳两种互相矛盾的正当性。",
    point: "观察点：影片有没有留出一个「我最不想承认自己理解他」的角色？",
  },
  {
    id: "lonely",
    title: "孤独与亲密",
    icon: "ri-heart-2-line",
    desc: "人们渴望被看见，又害怕被看穿。很多关系危机并非缺爱，而是缺乏把脆弱说出口的能力。",
    point: "观察点：两个人真正交谈过几次？还是只在各自陈述？",
  },
  {
    id: "identity",
    title: "身份与表演",
    icon: "ri-user-line",
    desc: "为了维持体面，人常在社会角色里演出一个版本。当演出持续太久，就会与真实自我彻底脱节。",
    point: "观察点：谁在镜头前表演，谁在独处时卸下妆？",
  },
  {
    id: "guilt",
    title: "罪与宽恕",
    icon: "ri-book-2-line",
    desc: "罪责的分配很少干净利落。真正的难题不是「谁有罪」，而是罪人是否值得被理解，受害者是否必须宽恕。",
    point: "观察点：影片结尾给出的是惩罚，还是继续生活的姿势？",
  },
];